import React from 'react';
import './PrivacyPolicy.scss';

const PrivacyPolicy = () => {
  return (
    <div className='main__wrapper'>
        <div className='header'>
            <div className='header__content'>
              <h2>Alfan</h2>
              <p>Privacy Policy</p>
            </div>
        </div>
        <div className='content'>
            <div className='content__wrapper'>
                <div className='privacy__policy'><h1>Privacy Policy for Alfan Digital Media Group FZ-LLC</h1></div>
                <div className='privacy__para textColor'>
                At Alfan Group, accessible from www.alfangroup.com, one of our main priorities is the privacy of our visitors. This Privacy Policy document contains types of information that is collected and recorded by Alfan Group and how we use it.
                </div>
                <br />
                <div className='privacy__para textColor'>
                If you have additional questions or require more information about our Privacy Policy, do not hesitate to contact us.
                </div>
                <br />
                <div className='privacy__para textColor'>
                This Privacy Policy applies only to our online activities and is valid for visitors to our website with regards to the information that they shared and/or collect in Alfan Group. This policy is not applicable to any information collected offline or via channels other than this website.
                </div>
                <br />
                <div className='privacy__description'><h3>Consent</h3></div>
                <div className='privacy__description__point textColor'>
                  <div className='privacy__para textColor'>
                  By using our website, you hereby consent to our Privacy Policy and agree to its terms.
                  </div>    
                </div>
                <br />
                <div className='privacy__description'><h3>Information we collect</h3></div>
                <div className='privacy__description__point textColor'>
                  <div className='privacy__para textColor'>
                  The personal information that you are asked to provide, and the reasons why you are asked to provide it, will be made clear to you at the point we ask you to provide your personal information.
                  </div> 
                  <div className='privacy__para textColor'>
                  If you contact us directly, we may receive additional information about you such as your name, email address, phone number, the contents of the message and/or attachments you may send us, and any other information you may choose to provide.
                  </div> 
                  <div className='privacy__para textColor'>
                  When you register for an Account, we may ask for your contact information, including items such as name, company name, address, email address, and telephone number.
                  </div>    
                </div>
                <br />
                <div className='privacy__description'><h3>How we use your information</h3></div>
                <div className='privacy__description__point textColor'>
                  <div className='privacy__para textColor'>
                  We use the information we collect in various ways, including to:
                  </div> 
                  <div className='desc__points'>
                      <ul>
                          <li>Provide, operate, and maintain our website</li>
                          <li>Improve, personalize, and expand our website</li>
                          <li>Understand and analyze how you use our website</li>
                          <li>Develop new products, services, features, and functionality</li>
                          <li>Communicate with you, either directly or through one of our partners, including for customer service, to provide you with updates and other information relating to the website, and for marketing and promotional purposes</li>
                          <li>Send you emails</li>
                          <li>Find and prevent fraud</li>
                      </ul>
                  </div> 
                </div>
                <br />
                <div className='privacy__description'><h3>Log Files</h3></div>
                <div className='privacy__description__point textColor'>
                  <div className='privacy__para textColor'>
                  Alfan Group follows a standard procedure of using log files. These files log visitors when they visit websites. All hosting companies do this and a part of hosting service&apos;s analytics. The information collected by log files include internet protocol (IP) addresses, browser type, Internet Service Provider (ISP), date and time stamp, referring/exit pages, and possibly the number of clicks. These are not linked to any information that is personally identifiable. The purpose of the information is for analyzing trends, administering the site, tracking user&apos;s movement on the website, and gathering demographic information.
                  </div>    
                </div>
                <br />
                <div className='privacy__description'><h3>Cookies and Web Beacons</h3></div>
                <div className='privacy__description__point textColor'>
                  <div className='privacy__para textColor'>
                  Like any other website, Alfan Group uses &apos;cookies&apos;. These cookies are used to store information including visitor&apos;s preferences, and the pages on the website that the visitor accessed or visited. The information is used to optimize the user&apos;s experience by customizing our web page content based on visitors&apos;s browser type and/or other information.
                  </div>    
                </div>
                <br />
                <div className='privacy__description'><h3>Google DoubleClick DART Cookie</h3></div>
                <div className='privacy__description__point textColor'>
                  <div className='privacy__para textColor'>
                  Google is one of a third-party vendor on our site. It also uses cookies, known as DART cookies, to serve ads to our site visitors based upon their visit to www.website.com and other sites on the internet. However, visitors may choose to decline the use of DART cookies by visiting the Google ad and content network Privacy Policy at the following URL – <a href="https://policies.google.com/technologies/ads">https://policies.google.com/technologies/ads</a>
                  </div>    
                </div>
                <br />
                <div className='privacy__description'><h3>Our Advertising Partners</h3></div>
                <div className='privacy__description__point textColor'>
                  <div className='privacy__para textColor'>
                  Some of advertisers on our site may use cookies and web beacons. Our advertising partners are listed below. Each of our advertising partners has their own Privacy Policy for their policies on user data. For easier access, we hyperlinked to their Privacy Policies below.
                  </div>  
                  <div className='desc__points'>
                      <ul>
                          <li>Google <a href="https://policies.google.com/technologies/ads">https://policies.google.com/technologies/ads</a></li>
                      </ul>
                  </div>   
                </div>
                <br />
                <div className='privacy__description'><h3>Advertising Partners Privacy Policies</h3></div>
                <div className='privacy__description__point textColor'>
                  <div className='privacy__para textColor'>
                  You may consult this list to find the Privacy Policy for each of the advertising partners of Alfan Group.
                  </div>
                  <div className='privacy__para textColor'>
                  Third-party ad servers or ad networks uses technologies like cookies, JavaScript, or Web Beacons that are used in their respective advertisements and links that appear on Alfan Group, which are sent directly to user&apos;s browser. They automatically receive your IP address when this occurs. These technologies are used to measure the effectiveness of their advertising campaigns and/or to personalize the advertising content that you see on websites that you visit.
                  </div>
                  <div className='privacy__para textColor'>
                  Note that Alfan Group has no access to or control over these cookies that are used by third-party advertisers.
                  </div>   
                </div>
                <br />
                <div className='privacy__description'><h3>Third Party Privacy Policies</h3></div>
                <div className='privacy__description__point textColor'>
                  <div className='privacy__para textColor'>
                  Alfan Group&apos;s Privacy Policy does not apply to other advertisers or websites. Thus, we are advising you to consult the respective Privacy Policies of these third-party ad servers for more detailed information. It may include their practices and instructions about how to opt-out of certain options.
                  </div>
                  <div className='privacy__para textColor'>
                  You can choose to disable cookies through your individual browser options. To know more detailed information about cookie management with specific web browsers, it can be found at the browser&apos;s respective websites.
                  </div>   
                </div>
                <br />
                <div className='privacy__description'><h3>CCPA Privacy Rights (Do Not Sell My Personal Information)</h3></div>
                <div className='privacy__description__point textColor'>
                  <div className='privacy__para textColor'>
                  Under the CCPA, among other rights, California consumers have the right to:
                  </div>
                  <div className='privacy__para textColor'>
                  Request that a business that collects a consumer&apos;s personal data disclose the categories and specific pieces of personal data that a business has collected about consumers.
                  </div> 
                  <div className='privacy__para textColor'>
                  Request that a business delete any personal data about the consumer that a business has collected.
                  </div> 
                  <div className='privacy__para textColor'>
                  Request that a business that sells a consumer&apos;s personal data, not sell the consumer&apos;s personal data.
                  </div> 
                  <div className='privacy__para textColor'>
                  If you make a request, we have one month to respond to you. If you would like to exercise any of these rights, please contact us.
                  </div>   
                </div>
                <br />
                <div className='privacy__description'><h3>GDPR Data Protection Rights</h3></div>
                <div className='privacy__description__point textColor'>
                  <div className='privacy__para textColor'>
                  We would like to make sure you are fully aware of all of your data protection rights. Every user is entitled to the following:
                  </div>
                  <div className='privacy__para textColor'>
                  The right to access – You have the right to request copies of your personal data. We may charge you a small fee for this service.
                  </div> 
                  <div className='privacy__para textColor'>
                  The right to rectification – You have the right to request that we correct any information you believe is inaccurate. You also have the right to request that we complete the information you believe is incomplete.
                  </div> 
                  <div className='privacy__para textColor'>
                  The right to erasure – You have the right to request that we erase your personal data, under certain conditions.
                  </div> 
                  <div className='privacy__para textColor'>
                  The right to restrict processing – You have the right to request that we restrict the processing of your personal data, under certain conditions.
                  </div> 
                  <div className='privacy__para textColor'>
                  The right to object to processing – You have the right to object to our processing of your personal data, under certain conditions.
                  </div> 
                  <div className='privacy__para textColor'>
                  The right to data portability – You have the right to request that we transfer the data that we have collected to another organization, or directly to you, under certain conditions.
                  </div> 
                  <div className='privacy__para textColor'>
                  If you make a request, we have one month to respond to you. If you would like to exercise any of these rights, please contact us.
                  </div>   
                </div>
                <br />
                <div className='privacy__description'><h3>Children&apos;s Information</h3></div>
                <div className='privacy__description__point textColor'>
                  <div className='privacy__para textColor'>
                  Another part of our priority is adding protection for children while using the internet. We encourage parents and guardians to observe, participate in, and/or monitor and guide their online activity.
                  </div>
                  <div className='privacy__para textColor'>
                  Alfan Group does not knowingly collect any Personal Identifiable Information from children under the age of 13. If you think that your child provided this kind of information on our website, we strongly encourage you to contact us immediately and we will do our best efforts to promptly remove such information from our records.
                  </div>  
                </div>
                <br />
            </div>         
        </div>
    </div>
  );
};

export default PrivacyPolicy;
